/**
 * DISTRIBUTION-MAP MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 */

// layout: "bottom" (wrapped row under the map) | "right" (vertical column).
// textColor: the legend label color (map_legend_text_color; defaults dark).
// offsetTop: px to push a right-side legend down so its top lines up with the
//   VT callout box (matches the export).
export default function DistributorLegend({ distributors, layout = "bottom", textColor = "#1f2937", offsetTop = 0 }) {
  if (!distributors || distributors.length === 0) return null;
  const visible = distributors.filter((d) => d.show_on_map !== false);
  if (visible.length === 0) return null;
  const right = layout === "right";
  return (
    <ul
      className={`legend ${right ? "legend-col" : ""}`}
      style={{
        display: "flex",
        flexDirection: right ? "column" : "row",
        gap: right ? 8 : 12,
        flexWrap: right ? "nowrap" : "wrap",
        listStyle: "none",
        padding: 0,
        margin: right ? `${offsetTop}px 0 0` : "8px 0 0",
      }}
    >
      {visible.map((d) => (
        <li key={d.id ?? d.name} style={{ display: "inline-flex", gap: 6, alignItems: "center" }}>
          <span
            aria-hidden
            style={{
              width: 12, height: 12, borderRadius: 3,
              background: d.color_hex || "#9ca3af",
              border: "1px solid rgba(0,0,0,.15)",
              display: "inline-block",
              flex: "0 0 auto",
            }}
          />
          <span style={{ fontSize: 13, color: textColor }}>{d.public_name || d.name}</span>
        </li>
      ))}
    </ul>
  );
}
